import {shift} from 'constants/url';
import useDelete from 'components/hooks/useDelete';
import {DeletingOptions} from '../../../components/grid-dx/types';

function useDeleteTurn() {
  const deleteTurn = useDelete(shift);
  return (deletingOptions: DeletingOptions) => deleteTurn(deletingOptions);
}

export default useDeleteTurn;
